(function () {
  function updateLoopiePoints(totalPriceInCents) {
    var el = document.querySelector('[data-loopie-points-value]');
    if (!el) return;
    el.textContent = Math.round(totalPriceInCents * 3 / 10000);
  }

  function fetchAndUpdate() {
    fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateLoopiePoints(cart.total_price); })
      .catch(function () {});
  }

  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) {
      updateLoopiePoints(e.detail.cart.total_price);
    } else {
      fetchAndUpdate();
    }
  });

  document.addEventListener('cart:build', fetchAndUpdate);
  document.addEventListener('drawerOpen.CartDrawer', fetchAndUpdate);
})();
